module.exports = __webpack_public_path__ + "img/logo_apleventis_ori.39508bc6.jpg";